module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"work":"Работают","error":"Ошибка"},"en":{"work":"Work","error":"Error"}}')
  delete Component.options._Ctor
}
